import enquireJs from 'enquire.js';

var enquireScreen = function enquireScreen(call) {
  // tablet
  var handler = {
    match: function match() {
      call && call(0);
    },
    unmatch: function unmatch() {
      call && call(-1);
    }
  }; // mobile

  var handler2 = {
    match: function match() {
      call && call(1);
    }
  };
  enquireJs.register('screen and (max-width: 1087.99px)', handler);
  enquireJs.register('screen and (max-width: 767.99px)', handler2);
};

export default enquireScreen;